

























































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component({ name: 'our-story-page' })
export default class OurStoryComponent extends Vue {
}
